import store from "@/store";

interface User {
    id: number;
    nombre: string;
    email: string;
    tutorial: number;
    two_steps: number;
    control_account: number;
    privacity_check: number;
    access_token: string;
    expires_at: string;
    empresas_usuario: Array<{ id: number; nombre: string; rut: string; validado: number }>;
    transferencias: Array<{ id: number; nombre: string; rut: string; validado: number }>;
}

export async function handleSuccessfulLogin(user:User, accessToken:string, expires_at:string) {

    let empresasValidas = [];
    if(user && user.empresas_usuario){
        empresasValidas = user.empresas_usuario.filter((el: any) => el.validado !== 0);
    }

    const empresasValidasLength = empresasValidas.length;
    store.commit("setMenu", null);
    store.commit("setUser", user);
    store.commit("setToken", accessToken);
    store.commit("setExpireTime", expires_at);
    store.commit("setTransferencias", user.transferencias);
    store.commit("setEmpresas", empresasValidasLength);
    store.commit("setPrivacityCheck", user.privacity_check);
    store.commit("setTempToken", null);

}